module.exports = __webpack_public_path__ + "img/CampaignOutlined.060bc937.svg";